// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"c1e464f1","693":"bebd0b90"}[chunkId] + ".chunk.js";
};